import React from 'react';

import { Hidden } from '@material-ui/core';
import styled from 'styled-components';

import Breadcrumbs from '@navigation/Breadcrumbs';
import FormRepresentant from '@components/Forms/FormRepresentant';

const ContainerForm = styled.div`
  margin-top: 25px;
  display: flex;
  justify-content: center;
  ${({ theme }) => theme.newBreakpoint('sm')} {
    margin-top: 0;
  }
`;

const EditRepresentant = ({ route }) => (
  <>
    <Hidden xsDown>
      <Breadcrumbs route={route} />
    </Hidden>
    <ContainerForm>
      <FormRepresentant />
    </ContainerForm>
  </>
);

export default EditRepresentant;
